import { InputFromUser } from '../Input/input';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

/**
 * DoDontSection Component
 * 
 * Extracts all "Do's and Don'ts" selection logic from the appointment details form.
 * Handles do's and don'ts checkbox/radio selections for lifestyle recommendations.
 * Maintains all existing functionality including form validation and state management.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.values - Formik values object
 * @param {Object} props.errors - Formik errors object
 * @param {Object} props.touched - Formik touched object
 * @param {Function} props.handleChange - Formik handleChange function
 * @param {Function} props.handleBlur - Formik handleBlur function
 * @param {Function} props.setFieldValue - Formik setFieldValue function
 * @param {boolean} props.IsFilledForm - Whether the form is filled/completed
 * @param {Object} props.ConsultationMasterData - Master data for consultation
 */
const DoDontSection = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  IsFilledForm,
  ConsultationMasterData,
}) => {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body p-3">
            <div className="mb-3">
              <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FeatherIcon icon="thumbs-up" size="20" style={{ color: '#4f46e5' }} />
                Lifestyle Advice (Do&apos;s & Don&apos;ts)
              </h4>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <InputFromUser
                  disabled={IsFilledForm}
                  placeholder={'Select Do'}
                  type="multiple"
                  options={
                    (ConsultationMasterData?.doAndDonts &&
                      ConsultationMasterData?.doAndDonts?.map(v => v.title)) ||
                    []
                  }
                  name="dos"
                  onChange={v => {
                    handleChange({
                      target: {
                        name: 'dos',
                        value: v,
                      },
                    });
                  }}
                  value={values.dos}
                  FormGroupClassName={'w-100'}
                  LabelClassName={'col-form-label'}
                  onBlur={undefined}
                  label="Do"
                />
              </div>
              <div className="col-12 col-md-6">
                <InputFromUser
                  disabled={IsFilledForm}
                  placeholder={"Select Don't"}
                  type="multiple"
                  options={
                    (ConsultationMasterData?.doAndDonts &&
                      ConsultationMasterData?.doAndDonts?.map(v => v.title)) ||
                    []
                  }
                  name="donts"
                  onChange={v => {
                    handleChange({
                      target: {
                        name: 'donts',
                        value: v,
                      },
                    });
                  }}
                  value={values.donts}
                  FormGroupClassName={'w-100'}
                  LabelClassName={'col-form-label'}
                  onBlur={undefined}
                  label="Don't"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoDontSection;